var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3333 19.5295V24.0002C26.3333 24.9168 25.5833 25.6668 24.6666 25.6668H11.3333C10.4166 25.6668 9.66663 24.9168 9.66663 24.0002L9.67496 14.0002C9.67496 13.0835 10.4166 12.3335 11.3333 12.3335H18.2345C18.0818 12.8626 18 13.4218 18 14.0001C18 15.295 18.4102 16.4941 19.1077 17.4745L18 18.1668L11.3333 14.0002V15.6668L18 19.8335L20.0738 18.5373C21.1261 19.4487 22.4987 20.0001 24 20.0001C24.8276 20.0001 25.616 19.8326 26.3333 19.5295Z",
    fill: "#FFC20E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 9C21.24 9 19 11.24 19 14C19 16.76 21.24 19 24 19C26.76 19 29 16.76 29 14C29 11.24 26.76 9 24 9ZM24 11.5C23.725 11.5 23.5 11.725 23.5 12V13.5H22C21.725 13.5 21.5 13.725 21.5 14C21.5 14.275 21.725 14.5 22 14.5H23.5V16C23.5 16.275 23.725 16.5 24 16.5C24.275 16.5 24.5 16.275 24.5 16V14.5H26C26.275 14.5 26.5 14.275 26.5 14C26.5 13.725 26.275 13.5 26 13.5H24.5V12C24.5 11.725 24.275 11.5 24 11.5ZM20 14C20 16.205 21.795 18 24 18C26.205 18 28 16.205 28 14C28 11.795 26.205 10 24 10C21.795 10 20 11.795 20 14Z",
    fill: "#007531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewMessage);
export default __webpack_public_path__ + "static/media/add-new-message.75aeca42.svg";
export { ForwardRef as ReactComponent };